import { render, staticRenderFns } from "./TheNewFormView.vue?vue&type=template&id=a75d5058&scoped=true&"
import script from "./TheNewFormView.vue?vue&type=script&lang=js&"
export * from "./TheNewFormView.vue?vue&type=script&lang=js&"
import style0 from "./TheNewFormView.vue?vue&type=style&index=0&id=a75d5058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75d5058",
  null
  
)

export default component.exports